import React from 'react';
import PropTypes from "prop-types";
import axios from 'axios';
import Spinner from "../../../qwc2/components/widgets/Spinner";
import LocaleUtils from "../../../qwc2/utils/LocaleUtils";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import FeatureUtils from "../../utils/FeatureUtils";
import ReactECharts from 'echarts-for-react';
import cloneDeep from 'lodash/cloneDeep';

class EchartTab extends AbstractTab {

    static propTypes = {
        feature: PropTypes.object,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            isLoading: true
        };
    }

    componentDidMount() {
        const url = FeatureUtils.prepareUrl(this.props.feature, this.props.tab.url);
        const self = this;
        axios(url).then(response => {
            self.setState({
                data: response.data,
                isLoading: false
            });
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }

    render() {
        return (
            <div className="feature-details-ajax">
                {this.state.isLoading &&
                    <div>
                        <Spinner/>
                        <div>{LocaleUtils.tr("attribtable.loading")}</div>
                    </div>
                }
                {!this.state.isLoading &&
                    <div>
                        {this.renderData()}
                    </div>
                }
            </div>
        );
    }

    replaceData(obj) {
        const regex = new RegExp("{([a-z]+)}");
        const that = this;
        Object.keys(obj).forEach(k => {
            const v = obj[k];
            if (typeof v === 'object') {
                that.replaceData(v);
            }
            if (typeof v === 'string') {
                const results = regex.exec(v);
                if (results && results.length == 2) {
                    const key = results[1];
                    if (this.state.data[key]) {
                        obj[k] = this.state.data[key];
                    }
                }
            }
        });
    }

    renderData() {
        const options = cloneDeep(this.props.tab.config);
        this.replaceData(options);
        if (typeof options.tooltip.formatter === 'string') {
            const template = options.tooltip.formatter;

            options.tooltip.formatter = function (param) {
                if (param.constructor && param.constructor === Array) {
                    param = param[0];
                }
                let html = template;
                html = html.replaceAll('{param.name}', param.name);
                if (param.data && param.data.length) {
                    for (let i = 0; i < param.data.length; i++) {
                        html = html.replaceAll('{param.data[' + i + ']}', param.data[i]);
                    }
                }
                return html;
            };
        }

        const key = "eck" + this.props.feature.properties.id;

        // add a formatter to the series using the locale string
        if (options && options.series && options.series[0] && options.series[0].label) {
            if (typeof options.series[0].label.formatter === 'string') {
                const labelTemplate = options.series[0].label.formatter;
                options.series[0].label.formatter = function (params) {
                    let newLabel = labelTemplate;
                    newLabel = newLabel.replaceAll('{a}', params.seriesName);
                    newLabel = newLabel.replaceAll('{b}', params.name);
                    newLabel = newLabel.replaceAll('{c}', params.value.toLocaleString());
                    newLabel = newLabel.replaceAll('{d}', params.percent.toLocaleString());
                    return newLabel;
                };
            }
        }

        // add a formatter for tooltips using the locale string
        if (options && options.tooltip) {
            options.tooltip.valueFormatter = value => value.toLocaleString();
        }

        return (
            <ReactECharts
                key={key}
                option={options}
                notMerge={false}
                lazyUpdate={false}
                theme={"theme_name"}
                opts={{ locale: 'DE' }}
            />
        );
    }
}

const
    selector = () => ({});

export default connect(selector, {})

(
    EchartTab
)
;
